export const TIER_NAMES = {
  TIER_1: 'tier1',
  TIER_2: 'tier2',
  QCSBP: 'all',
  SEVEN_NINE: '7_9',
};

export const FILTER_OPTIONS = {
  filterBy: 'oeCount',
};
